import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import "../../styles/commoncomponents/toggleBar.scss";
function HomePageToggleBar(props) {
  const [open, setOpen] = useState(props.open);

  return (
    <div className="barHomeContainer">
      <div className="barHeader">
        <div className="headerLeft">
          <h2>
            <p style={{ color: `${props.color}` }}>{props.value}</p>{" "}
            <span style={{ color: `${props.color}` }}>{props.caption}</span>
          </h2>
        </div>
        <div className="headerRight">
          <i
            className={`fa ${
              open ? "fa-minus-square-o" : "fa-plus-square-o"
            } toggle`}
            onClick={() => setOpen(!open)}
          />
        </div>
      </div>
      <Collapse in={open}>
        <div className="barContent" id="example-collapse-text">
          {/* <hr className="hrLine"/> */}
          <div className="content">{props.content || props.children}</div>
        </div>
      </Collapse>
    </div>
  );
}

export default HomePageToggleBar;
